<template>
  <div class="d-flex align-center">
    <p class="flex-shrink-0">เวลาที่เหลือ</p>
    <p class="flex-grow-1">{{ countdown }}</p>
  </div>
</template>

<script>
export default {
  data: () => ({
    countdown: "00 : 00 : 00",
    timerId: null,
    state: {
      normal: {
        color: "green"
      },
      near: {
        left: 10,
        color: "orange darken-2"
      },
      almost: {
        left: 3,
        color: "red darken-1"
      }
    },
    barColor: "green"
  }),
  methods: {
    onExpire() {
      this.$emit("expire","endTime");
    },
    startTimerOld(config) {
      this.cancelTimer();

      const endTime = this.$moment(config.end);
      const currTime = this.$moment(config.start);
      var duration = this.$moment.duration(
        endTime.diff(currTime),
        "milliseconds"
      );
      var interval = 1000;

      this.timerId = setInterval(() => {
        duration = this.$moment.duration(duration - interval, "milliseconds");
        let hrs = duration.hours();
        let min = duration.minutes();
        let sec = duration.seconds();
        // if (hrs > 0) {
        //   min += hrs * 60;
        // }
        if (config.endTime !== 0 && hrs == 0 && min == 0 && sec <= 0) {
          this.onExpire();
        } else {
          this.countdown = `${hrs
            .toString()
            .padStart(2, "0")} : ${min
            .toString()
            .padStart(2, "0")} : ${sec.toString().padStart(2, "0")}`;

          // color state
          if (hrs == 0) {
            if (min < this.state.almost.left) {
              this.barColor = this.state.almost.color;
            } else if (min < this.state.near.left) {
              this.barColor = this.state.near.color;
            }
          }
        }
      }, interval);
    },
    startTimer(config) {
      this.cancelTimer();

      const endTime = config.end
      const currTime = config.start

      let duration = endTime - currTime
      let interval = 1000;
      this.timerId = setInterval(() => {
        duration = duration - interval
        let days = Math.floor(duration / (1000 * 60 * 60 * 24));
        // let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let hours = Math.floor((duration) / (1000 * 60 * 60));
        let minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((duration % (1000 * 60)) / 1000);

        if (endTime !== 0 && duration < 0) {
          this.onExpire();
        } else {
          this.countdown = `${hours
            .toString()
            .padStart(2, "0")} : ${minutes
            .toString()
            .padStart(2, "0")} : ${seconds.toString().padStart(2, "0")}`;

          // color state
          if (hours == 0) {
            if (minutes < this.state.almost.left) {
              this.barColor = this.state.almost.color;
            } else if (minutes < this.state.near.left) {
              this.barColor = this.state.near.color;
            }
          }
        }
      }, interval);
    },
    cancelTimer() {
      this.barColor = this.state.normal.color;

      if (this.timerId != null) {
        clearInterval(this.timerId);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
p { 
  margin: 0; font-size: 1rem;

  &:nth-of-type(01) { color: #737e8a; margin-right: 8px; } 
} 
</style>